import { render, staticRenderFns } from "./SunburstChartRound.vue?vue&type=template&id=1edd448a&scoped=true"
import script from "./SunburstChartRound.vue?vue&type=script&lang=js"
export * from "./SunburstChartRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd448a",
  null
  
)

export default component.exports